import dayjs from "dayjs"

/**
 * 作業予定日に達しているかどうかを返す。
 *
 * 清掃予定日より前に開始・完了報告されると、報告日ベースの送金集計で
 * 誤った日付が対象になってしまうため、予定日以降のみ開始できるようにする。
 * `plan_date <= 今日` のとき true。
 *
 * @param taskDate YYYY-MM-DDの形式。取得できていない場合はブロックしない
 */
export const isTaskDateReached = (
    taskDate: string | undefined,
    now?: dayjs.ConfigType
): boolean => {
    if (!taskDate) return true

    return !dayjs(taskDate).isAfter(dayjs(now), "day")
}
